import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const Container = styled.div`
  .popup-body {
    padding: 16px 24px;
    border-bottom: 1px solid ${theme.colours.newOutline};
    padding-bottom: 0;
    @media (max-width: 768px) {
      padding: 16px !important;
    }
    label {
      p {
        color: #303030;
        font-family: ${theme.fonts.Regular};
        margin-bottom: 2px !important ;
      }
    }
    .wrapper {
      label {
        p {
          margin-bottom: 4px !important ;
        }
      }
    }
    .btn-date.mantine-Button-root {
      height: 32px !important;
      padding: 4px 12px !important;
      color: #000000 !important;
      justify-content: space-between !important;
      width: 100% !important;
      .mantine-Button-label {
        width: 100% !important;
      }
    }

    .mantine-Button-root {
      width: 100% !important;
      height: 28px !important;
      background-color: white !important;
      border: 0.5px solid ${theme.colours.newOutline} !important;
      padding: 9px 12px !important;
      border-radius: 8px !important;
    }
    .hasError {
      border: 1px solid ${theme.colours.error} !important;
    }
    .event-type-label {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #303030;
      padding-right: 12px;
    }
  }
  .popup-footer {
    padding: 12px 24px;
    @media (max-width: 768px) {
      padding: 16px !important;
    }
    button {
      span {
        line-height: 20px;
        font-size: 14px;
        height: 20px;
      }
    }
  }
  .container-select-wrapper {
    width: 100% !important;
  }
  .container-select {
    top: 0px !important;
    width: 100% !important;
  }
  .gap16 {
    gap: 16px;
  }
`;
